import axios from 'axios'
const api = axios.create({ baseURL: process.env.REACT_APP_BASE_URL })

export const getRequest = async (url) => {
  try {
    const response = await api.get(url)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    console.error("Error in getRequest:", error)
    throw error
  }
}

export const postRequest = async (url, data) => {
  try {
    const response = await api.post(url, data)
    return response.data
  } catch (error) {
    console.error("Error in postRequest:", error)
    throw error
  }
}